/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentResponseCancelledReason } from './enrollmentResponseCancelledReason';
import type { EnrollmentResponseResolvedEmailType } from './enrollmentResponseResolvedEmailType';
import type { EnrollmentResponseStatus } from './enrollmentResponseStatus';
import type { EnrollmentResponseWaterfallStrategy } from './enrollmentResponseWaterfallStrategy';

/**
 * Detail-page shape returned by ``GET /enrollments/{id}`` and by
 * pause/resume/cancel/restart.
 *
 * Embeds the most-recent ``EnrollmentPreviewCandidate``-shaped
 * candidate snapshot so the detail drawer can render without an
 * extra round-trip.
 */
export interface EnrollmentResponse {
  id: string;
  org_id: string;
  sequence_id: string;
  pinned_step_set_id: string;
  job_id: string;
  job_candidate_id: string;
  profile_id: string;
  sender_user_id: string;
  mailbox_id?: string | null;
  linkedin_account_id?: string | null;
  waterfall_strategy: EnrollmentResponseWaterfallStrategy;
  status: EnrollmentResponseStatus;
  /** @minimum 0 */
  current_step_index: number;
  next_due_at?: string | null;
  workflow_id?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
  cancelled_at?: string | null;
  cancelled_reason?: EnrollmentResponseCancelledReason;
  last_event_at?: string | null;
  failure_code?: string | null;
  failure_detail?: string | null;
  /** @minimum 0 */
  failure_count?: number;
  last_failure_at?: string | null;
  paused_reason?: string | null;
  last_resume_attempt_at?: string | null;
  resolved_email?: string | null;
  resolved_email_type?: EnrollmentResponseResolvedEmailType;
  resolved_phone?: string | null;
  resolved_linkedin_url?: string | null;
  /** @minimum 0 */
  messages_sent_count?: number;
  /** @minimum 0 */
  replies_received_count?: number;
  /** @minimum 0 */
  opens_count?: number;
  /** @minimum 0 */
  clicks_count?: number;
  /** @minimum 0 */
  bounced_count?: number;
  created_at: string;
  updated_at: string;
  created_by_user_id: string;
}
